/* GANVU wide photo: the image is fetched only when it comes within 400px of the screen, so on phones it does not
   share the connection with the images at the top of the page. Loaded as a module, so sections share one copy. */
const show = (img) => {
  img.sizes = img.dataset.sizes;
  img.srcset = img.dataset.srcset;
  img.removeAttribute('data-srcset');
};
const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  for (const entry of entries) {
    if (!entry.isIntersecting) continue;
    observer.unobserve(entry.target);
    show(entry.target);
  }
}, {rootMargin: '400px 0px'}) : null;
const setup = (root) => {
  for (const img of root.querySelectorAll('img.gv-photo-img--deferred[data-srcset]')) {
    if (observer) observer.observe(img); else show(img);
  }
};
setup(document);
document.addEventListener('shopify:section:load', (event) => setup(event.target));
